import axios from 'axios';
import store from '../store';
import alert from './alert';
import router from '@/router';
import { KEYS, getItem, removeItem } from '@/store/local/localStorage';

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSBLE_ENTITY: 422,
  BAD_REQUEST: 400,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

let loaderCount = 0;

const setLoader = loader => {
  if (loader) {
    loaderCount++;
    if (loaderCount === 1) {
      store.commit('loader/SET_LOADER');
    }
  }
};

const disableLoader = loader => {
  if (loader) {
    loaderCount--;
    if (loaderCount === 0) {
      store.commit('loader/RESET_LOADER');
    }
  }
};

const setDefaultOptions = options => {
  const token = getItem(KEYS.LOGIN.jwt);
  options.headers = {
    Authorization: token,
    ...options.headers
  };
  options.loader = options.loader !== false;
  return options;
};

const handleRequestPromisse = config => {
  config = setDefaultOptions(config);
  setLoader(config.loader);
  return new Promise((resolve, reject) => {
    axios(config)
      .then(response => {
        disableLoader(config.loader);
        resolve(response.data);
      })
      .catch(error => {
        disableLoader(config.loader);
        const status = error.response.status;
        const payload = error.response.data;
        if (status === HTTP_STATUS.UNPROCESSBLE_ENTITY) {
          return reject(payload);
        }
        if (status === HTTP_STATUS.SERVICE_UNAVAILABLE) {
          return reject(payload);
        }
        if (status === HTTP_STATUS.UNAUTHORIZED) {
          alert.error({
            title: 'Sua sessão expirou!',
            msg: 'Faça o login novamente.'
          });
          removeItem(KEYS.LOGIN.jwt);
          removeItem(KEYS.LOGIN.usuario);
          router.push({ name: 'logout' }).catch(() => {});
          return;
        }
        if (status >= HTTP_STATUS.INTERNAL_SERVER_ERROR) {
          alert.error({
            title: 'Sistema indisponível',
            msg: 'Entre em contato com o administrador!'
          });
          return;
        }
        reject(payload);
      });
  });
};

export default handleRequestPromisse;